/**
 * Set markers in layer
 *
 * @param {*} map
 * @param {*} layer
 * @param {*} markers
 * @param {*} data
 */

export function setMarkers(map, layer, data, markers) {
    layer.addData(data);

    if (markers) {
        markers.addLayer(layer);
        map.addLayer(markers);
    } else {
        map.addLayer(layer);
    }
}
